const allUSState = require("./states.json")
const allUSCities = require("./cities.json")
export { allUSState, allUSCities }
